/** Site-wide pre-launch indicator -- a classic corner-ribbon, fixed above all routed content so
 * it shows regardless of theme/page. Remove this file (and its one import in main.tsx) once the
 * site actually launches. */
export function ComingSoonBanner() {
  return (
    <div
      aria-hidden="true"
      style={{
        position: 'fixed',
        top: 18,
        left: -64,
        width: 240,
        transform: 'rotate(-45deg)',
        transformOrigin: 'center',
        background: 'linear-gradient(135deg, #d97706, #b45309)',
        color: '#fff',
        textAlign: 'center',
        padding: '6px 0',
        boxShadow: '0 2px 8px rgba(0,0,0,0.25)',
        zIndex: 9999,
        pointerEvents: 'none',
        fontFamily: 'system-ui, sans-serif',
      }}
    >
      <div style={{ fontSize: 13, fontWeight: 700, letterSpacing: 0.5 }}>Coming soon..</div>
      <div style={{ fontSize: 10, fontStyle: 'italic', opacity: 0.9, marginTop: 1 }}>
        server&apos;s still in its pajamas
      </div>
    </div>
  );
}
